import React from 'react'

import './press.scss'
import Layout from '../components/Layout/Layout'

const Press = ({ pathContext: { locale } }) => (
  <Layout locale={locale}>
    <div className="press row no-gutters">
      <div className="col-12 col-lg-6 articles">
        <h5 className="akkurat mb-4">Des gens qui disent du bien de nous :)</h5>

        <h6 className="courier-new">
          <u>
            <a
              href="https://www.doitinparis.com/fr/bons-rouleaux-de-printemps-paris-24394"
              target="_blank"
            >
              DO IT IN PARIS – 2019
            </a>
          </u>
        </h6>
        <p className="courier-new text">
          C’est une affaire qui roule. Le comptoir monomaniaque du 11e monté en 2016 par la
          ravissante My-Ly Pham délivre les meilleurs spring rolls de Paris toutes catégories. Son
          credo ? Une fabrication à la vietnamienne dans les règles de l’art sur une base de
          vermicelles de riz dans une atmosphère chill.
          <p className="mt-2">
            Au total, 7 recettes plus alléchantes les unes que les autres : porc à la citronnelle,
            carottes, pickles, concombre, cacahuètes ; omelette à la japonaise, avocat, oignons
            caramélisées ; saumon fumé, fromage frais. À dipper dans d’irrésistibles sauces maison.
          </p>
        </p>

        <h6 className="courier-new">
          <u>
            <a
              href="https://www.anousparis.fr/a-manger/la-tendance-est-aux-rouleaux-de-printemps-a-paris/?fbclid=IwAR2zc3beaSjuVrRTWgdt3enuF-0Ypof9NsApt-sSlvVhE3UJPv80QY3Uut0"
              target="_blank"
            >
              A NOUS PARIS – 2019
            </a>
          </u>
        </h6>
        <p className="courier-new text">
          Avec ce lot de nouvelles adresses, on en oublierait presque l’origine de ces galettes de
          riz garnies. Eh oui, car même s’il fait un retour en force dans la capitale, le rouleau de
          printemps reste néanmoins un grand classique de la gastronomie vietnamienne. D’ailleurs,
          My Ly est là pour nous le rappeler dans son adorable cantoche de poche. Avec de généreux
          rouleaux coupés en deux dans des paniers en bambou tradi, votre repas risque de vous faire
          voyager en terre lointaine. Et encore, c’est sans compter sur les assiettes dépareillées
          en porcelaine asiatique d’une mignonnerie absolue. Quand au café viet – avec ou sans sa
          larme de lait concentré sucré – au goût beurré, on en emporterait bien quelques litrons
          tellement il est bon.
        </p>

        <h6 className="courier-new">
          <u>
            <a
              href="https://www.vogue.fr/lifestyle/article/les-meilleurs-restaurants-vietnamiens-a-paris?fbclid=IwAR0ECqXda19URWa8GgnO2kS1nBe-TUjYHavYyo-CCd_69BpcLe-8WrokxCo"
              target="_blank"
            >
              VOGUE – 2019
            </a>
          </u>
        </h6>
        <p className="courier-new text">
          Chez Banoi, jolie table de la rue Amelot menée par la cheffe My-Ly, le rouleau de
          printemps est la star de la carte. Et pour cause, il est décliné selon des saveurs peu
          communes comme le mélange de crevettes, mangue, carottes et pickles ou encore le
          porc-citronnelle bourré de carottes, concombres et cacahuètes. Une idée différente du
          rouleau de printemps.
        </p>

        <h6 className="courier-new">LE PARISIEN – 2019</h6>
        <p className="courier-new text">
          « Comptoir en bois et petits pots de plantes grasses, le Banoi est une parenthèse zen au
          cœur de la ville. Dodus et savoureux, les rouleaux de printemps (3,50€ à la carte) sont la
          spécialité de la maison »
        </p>

        <h6 className="courier-new">
          <u>
            <a href="https://fr.gaultmillau.com/restaurant/banoi-restaurant" target="_blank">
              GAULT ET MILLAU – 2018
            </a>
          </u>
        </h6>
        <p className="courier-new text">
          Nichés dans une feuille de riz translucide, les vermicelles et les herbes fraîches
          s'enrobent de porc à la citronnelle acidulé à la carotte pickles ou de saumon teriyaki au
          gingembre grillé... Les gentils rouleaux de Banoi s'avalent en triplet plongés dans une
          soyeuse mayonnaise au sésame ou une sauce cacahuètes. Un gentil déjeuner vietnamien pour
          un peu moins de dix euros, juste ce qu'il faut pour se permettre un café autochtone -
          respectueusement sucrable au lait concentré - et boulotter un dessert qui embobine les
          fuseaux : chiffon-cake au pandan cotonneux ou génoise repliée autour d'une crème au sésame
          noir. Un peu à bout dans les gargotes parisiennes, voilà le rouleau de printemps
          ragaillardi par des recettes rondement bien roulées !
        </p>

        <h6 className="courier-new">FRAGONARD 2018</h6>
        <p className="courier-new text">
          Restaurant intimiste et sympathique, Banoi revisite le rouleau de printemps vietnamien. Au
          milieu d’une belle décoration au bois claire, rappelant celle des restaurants du pays, la
          cheffe My-Ly PHAM propose une carte aux déclinaisons originales. Venez découvrir un
          gourmant rouleau saumon-teriyaki ou un surprenant rouleau crevette-mangue, surmonté de
          délicieux pickles et d’oignons. En accompagnement, les sauces nuoc-mâm, peanuts et
          mayo-sésame sont un vrai délice.
        </p>

        <h6 className="courier-new">
          <u>
            <a
              href="https://www.telerama.fr/sortir/les-40-femmes-qui-agitent-la-gastronomie-parisienne,154973.php"
              target="_blank"
            >
              TELERAMA - Les 70 femmes qui agitent la gastronomie parisienne - 2017
            </a>
          </u>
        </h6>
        <p className="courier-new text">
          « Certes, une hirondelle ne fait pas le printemps... mais un rouleau peut nous en
          rapprocher ! Spécialité de cette mignonne cantine vietnamienne située à deux pas du Cirque
          d'Hiver, le rouleau de printemps se plie à toutes les fantaisies de My Ly Pham. Mêlés aux
          vermicelles de riz, lamelles de porc confit, tofu caramélisé, mangue, avocat, saumon
          mariné ou oignons frits offrent des variations bien tempérées au goi cuon. »
        </p>

        <h6 className="courier-new">
          <u>
            <a href="https://www.facebook.com/watch/?v=1495612030491064" target="_blank">
              TRES TRES BON – 2017
            </a>
          </u>
        </h6>
        <p className="courier-new text" />

        <h6 className="courier-new">
          <u>
            <a
              href="https://www.madmoizelle.com/portrait-my-ly-restaurant-banoi-701583"
              target="_blank"
            >
              MADMOIZELLE – 2017
            </a>
          </u>
        </h6>
        <p className="courier-new text">
          « Monter sa boîte quand on est jeune, c'est possible. Exemple avec My-Ly, passionnée de
          cuisine vietnamienne, qui a lancé son restaurant à 26 ans. »
        </p>
      </div>

      <div className="col-12 col-lg-6" />
    </div>
  </Layout>
)

export default Press



// WEBPACK FOOTER //
// ./src/pages/press.js